<template>
  <div class="stil-overview d-timetal__container">
    <h4 class="uppercase">Personale</h4>
    <table class="d-table">
      <thead class="center">
      <tr>
        <th rowspan="2" style="min-width: 225px"></th>
        <th rowspan="2">Antal personer</th>
        <th rowspan="2">Årsværk</th>
        <th colspan="2" style="text-align: center">Arbejdstimer</th>
        <th colspan="2" style="text-align: center">Fagopdelt undervisning</th>
        <th colspan="2" style="text-align: center">Understøttende undervisning</th>
        <th colspan="2" style="text-align: center">Øvrig tid med eleverne</th>
      </tr>
      <tr class="thead-second-row">
        <th>Normalklasser</th>
        <th>Specialklasser</th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(userType, idx) in stilDataRess" :key="userType.id">
        <td>{{ userType.title }}</td>
        <td>{{ userType.number_of_usertype }}</td>
        <td>{{ userType.years_of_work }}</td>
        <td>{{ userType.stil_hours_40_B }}</td>
        <td>{{ userType.stil_hours_50_B }}</td>
        <td>{{ userType.stil_hours_40_A1 }}</td>
        <td>{{ userType.stil_hours_50_A1 }}</td>
        <td>{{ userType.stil_hours_40_A22 }}</td>
        <td>{{ userType.stil_hours_50_A22 }}</td>
        <td>{{ userType.stil_hours_40_A33 }}</td>
        <td>{{ userType.stil_hours_50_A33 }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    stilData: {
      type: Object,
      default: () => {
      }
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    stilDataRessourceSkema () {
      return this.stilData && this.stilData.ressourceskema ? this.stilData.ressourceskema : []
    },
    userTypes () {
      return [
        {id: 'LE', title: 'Ledere'},
        {id: 'LA', title: 'Lærere'},
        {id: 'BH', title: 'BH klasseledere'},
        {id: 'PA', title: 'Pædagoger'},
        {id: 'AN', title: 'Andre med undervisningsopgaver'}
      ]
    },
    stilDataRess () {
      return this.userTypes.map(userType => {
        const userTypeObj = {
          id: userType.id,
          title: userType.title,
          number_of_usertype: this.getNumberOfUsertype(userType.id),
          years_of_work: this.getYearsOfWork(userType.id),
          stil_hours_40_B: this.getHoursPerUserType(userType.id, '40', 'B'),
          stil_hours_50_B: this.getHoursPerUserType(userType.id, '50', 'B'),
          stil_hours_40_A1: this.getHoursPerUserType(userType.id, '40', 'A1'),
          stil_hours_50_A1: this.getHoursPerUserType(userType.id, '50', 'A1'),
          stil_hours_40_A22: this.getHoursPerUserType(userType.id, '40', 'A22'),
          stil_hours_50_A22: this.getHoursPerUserType(userType.id, '50', 'A22'),
          stil_hours_40_A33: this.getHoursPerUserType(userType.id, '40', 'A33'),
          stil_hours_50_A33: this.getHoursPerUserType(userType.id, '50', 'A33')
        }
        return userTypeObj
      })
    }
  },
  methods: {
    getNumberOfUsertype (personaletype) {
      return this.users.filter(user => user.v_stil_stilling === personaletype).length
    },
    getHoursPerUserType (personaletype, klassetype, tidstype) {
      const idx = this.stilDataRessourceSkema.findIndex(skema => skema.personaletype === personaletype && skema.klassetype === klassetype && personaletype && skema.tidstype === tidstype)
      return idx > -1 ? this.stilDataRessourceSkema[idx]['timer'] : 0
    },
    getYearsOfWork (personaletype) {
      const normalKlasse = this.getHoursPerUserType(personaletype, '40', 'B') * 1
      const specialKlasse = this.getHoursPerUserType(personaletype, '50', 'B') * 1
      const sum = normalKlasse + specialKlasse
      return (sum / 1924).toFixed(2)
    }
  }
}
</script>

<style scoped>

.uppercase {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.d-timetal__container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

.d-table tbody tr td:not(:first-child) {
  text-align: right;
}

thead.center th {
  text-align: center;
  font-size: 10px;
  border: 1px solid #d8d8d8;
  line-height: 1.2;
}

thead tr.thead-second-row th {
  font-size: 10px;
}

</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningRessourceOverview.vue?5c36c080